import { render, staticRenderFns } from "./CustomersNew.vue?vue&type=template&id=9659cdfc"
import script from "./CustomersNew.vue?vue&type=script&lang=js"
export * from "./CustomersNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports